import { Capacitor } from '@capacitor/core';

export type BillingMode = 'interactive' | 'native_read_only';

/** Roda dentro do bundle nativo (iOS/Android), não no browser. */
export function isNative(): boolean {
  return Capacitor.isNativePlatform();
}

/**
 * Modo do ecrã de billing.
 *
 * Em nativo é **informativo** (`native_read_only`): assinaturas e KYC acontecem em superfície
 * web (Stripe Checkout / Connect Express). Isto não é preferência de arquitetura — é o que
 * evita a obrigação de compra in-app da **App Store Guideline 3.1.3(e)** (PRD §4.6.2).
 * Abrir checkout dentro do WebView nativo é motivo de rejeição, não bug de UI.
 */
export function billingMode(): BillingMode {
  return isNative() ? 'native_read_only' : 'interactive';
}

/** O painel administrativo nunca faz parte do bundle nativo (§4.6.6). */
export const ADMIN_IS_WEB_ONLY = true;

/**
 * Acompanha a barra de status nativa com o tema ativo (§6.10).
 *
 * Ligado ao `onThemeChange` do `ThemeProvider` (criado na T0.2 exatamente para esta porta),
 * de modo que o provider não precise conhecer o Capacitor.
 *
 * Em web é no-op: sem isto, todo teste de tema teria de mockar o plugin nativo.
 * O import é dinâmico para que o browser não carregue o plugin que nunca vai usar.
 */
export async function applyStatusBarTheme(theme: 'dark' | 'light'): Promise<void> {
  if (!isNative()) return;

  const { StatusBar, Style } = await import('@capacitor/status-bar');
  // Style.Dark = conteúdo claro sobre fundo escuro. O nome do enum descreve o TEMA,
  // não a cor do texto — trocar os dois é o erro clássico aqui.
  await StatusBar.setStyle({ style: theme === 'dark' ? Style.Dark : Style.Light });
}
